import React from "react";

const Breadcrumb = ({ heading, name }) => {
  return (
    <div className="container-fluid bg-pink pb-20 pt-24">
      <div className="flex flex-col items-center justify-center">
        <h2 className="heading_h2 text-black">{heading}</h2>
        <p>
          Home <span>-</span> {name ? name : ""} {heading}
        </p>
      </div>
    </div>
  );
};

export default Breadcrumb;
